import { RestError } from "../../services/rest-service/RestService";
import { useQuery } from "react-query";
import { IUserSettings } from "../../services/user-settings-data/Models";
import UserSettingsDataService from "../../services/user-settings-data/UserSettingsDataService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UserSettingQueryParameters = {
} & BaseUseQueryParameters<IUserSettings | undefined>

export function useUserSettings(params: UserSettingQueryParameters) {
    return useQuery<IUserSettings | undefined, RestError>(
        keys.settings(),
        ({ signal }) => {
            return UserSettingsDataService.getUserSettings(signal);
        },
        {
            enabled: params.enabled,
            onError: params.onError,
            onSuccess: params.onSuccess,
            refetchInterval: params.refreshSeconds ? params.refreshSeconds  * 1000 : false
        }
    );
}
// export function useUserSettings(
//     userID: number | undefined,
//     enabled?: boolean,
//     onSuccess?: (data: IUserSettings | undefined) => void,
//     onError?: (error: RestError) => void,    
// ) {
//     return useQuery<IUserSettings | undefined, RestError>(
//         //keys.settings(userID),
//         keys.settings(),
//         ({ signal }) => {
//             //if (userID !== undefined) {
//                 return UserSettingsDataService.getUserSettings(signal);

//             //}
//         },
//         {
//             enabled,
//             onError: onError,
//             onSuccess: onSuccess,
//             //keepPreviousData: true
//         }
//     );
// }
